import StatusTag from './StatusTag.component';

export default StatusTag;
